<template>
  <div class="sidebar-top sidebar-fixed d-print-none">
    <h3 class="mb-5">{{ $t('toc') }}</h3>
    <ol class="sidebar-list link-list" v-if="headings.length">
      <li v-for="heading in headings" :key="heading.id">
        <a href="#" @click.prevent="scrollTo(heading.id)">{{ heading.textContent }}</a>
      </li>
    </ol>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { scrollTo } from '../utils/scroll';

let container;

export default {
  computed: {
    ...mapState('page', ['currentPage']),

    headings() {
      if (!this.currentPage) {
        return [];
      }

      container = container || document.createElement('div');
      container.innerHTML = this.currentPage.content;
      const headings = Array.from(container.querySelectorAll('h4'));
      container.innerHTML = '';

      return headings;
    },
  },
  methods: {
    scrollTo,
  },
};
</script>
